import { s, c, t } from '../val.config';

export const schema = s.object({
  numberOfTimesToRepeatImages: s.number(),
  shuffleImages: s.boolean(),
  showImageCaptions: s.boolean(),
  pictures: s.array(s.image()),
});

export type DarkSide = t.inferSchema<typeof schema>;

export default c.define('/settings/darkside.val.ts', schema, {
  numberOfTimesToRepeatImages: 4,
  shuffleImages: true,
  showImageCaptions: false,
  pictures: [
    {
      path: '/public/val/sommerfest_vetle_sandra_93bda.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
      alt: 'sommerfest',
    },
    {
      path: '/public/val/italia_is_f410f.webp',
      width: 2000,
      height: 1500,
      mimeType: 'image/webp',
      alt: 'italia',
    },
    {
      path: '/public/val/jobbe_fugleperspektiv_7a867.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/polaroid_lars_max_5dc51.webp',
      width: 1340,
      height: 817,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/italia_clara_52194.webp',
      width: 2000,
      height: 1500,
      mimeType: 'image/webp',
      alt: 'Italia',
    },
    {
      path: '/public/val/bok_51fb2.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
      alt: 'nye bøker',
    },
    {
      path: '/public/val/kjoregar_b8f70.png',
      width: 2000,
      height: 2667,
      mimeType: 'image/png',
      alt: 'kjøregår i stratosfæren',
    },
    {
      path: '/public/val/polaroid_mats_977d6.webp',
      width: 1335,
      height: 820,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/knut_poker_db036.webp',
      width: 2000,
      height: 2167,
      mimeType: 'image/webp',
      alt: 'gambling',
    },
    {
      path: '/public/val/polaroid_lars_isak_bccf0.webp',
      width: 770,
      height: 484,
      mimeType: 'image/webp',
      alt: 'finn deg noen som ser på deg sånn som Isak ser på Smeby',
    },
    {
      path: '/public/val/fugl_dc5cd.webp',
      width: 1906,
      height: 1906,
      mimeType: 'image/webp',
      alt: 'peace',
    },
    {
      path: '/public/val/vaffelfredag_f4c71.png',
      width: 2000,
      height: 2667,
      mimeType: 'image/png',
      alt: 'vaffelfredag',
    },
    {
      path: '/public/val/polaroid_vetle_779fe.webp',
      width: 2000,
      height: 1337,
      mimeType: 'image/webp',
      alt: 'finse casino',
    },
    {
      path: '/public/val/sommerfest_amadou_sergey_2777a.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
      alt: 'Sommerfest 2025',
    },
    {
      path: '/public/val/polaroid_neva_88104.webp',
      width: 1339,
      height: 826,
      mimeType: 'image/webp',
      alt: 'å',
    },
    {
      path: '/public/val/sommerfest_djs_a5a81.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
      alt: 'boss djs',
    },
    {
      path: '/public/val/polaroid_nre_d41af.webp',
      width: 1345,
      height: 826,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/images/1c1e024ce34b24a871c40380012ea2e2462a7979-900x678.gif',
      width: 900,
      height: 678,
      mimeType: 'image/gif',
    },
    {
      path: '/public/val/polaroid_erlend_9298d.webp',
      width: 1345,
      height: 834,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/jotunheimen_2_3f159.webp',
      width: 1365,
      height: 2048,
      mimeType: 'image/webp',
      alt: 'f',
    },
    {
      path: '/public/val/polaroid_lars_magne_ba844.webp',
      width: 768,
      height: 477,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/sydney_mathilde_e97de.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
      alt: 'kontordog',
    },
    {
      path: '/public/val/itala_langbord_b780d.webp',
      width: 2000,
      height: 1500,
      mimeType: 'image/webp',
      alt: 'Italia',
    },
    {
      path: '/public/val/polaroid_jon_48ef2.webp',
      width: 1342,
      height: 809,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/oppstart_sverige_764ba.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
      alt: 'Oppstartsuker',
    },
    {
      path: '/public/val/polaroid_jonas_neva_40c83.webp',
      width: 824,
      height: 1330,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/oya_gjeng_7494d.png',
      width: 2000,
      height: 1125,
      mimeType: 'image/png',
      alt: 'Øya',
    },
    {
      path: '/public/val/images/d16b762bb1d4d4169f0bc73c5ba20bed7ddcfd48-769x483.gif',
      width: 769,
      height: 483,
      mimeType: 'image/gif',
      alt: 'Mr boss man',
    },
    {
      path: '/public/val/pizza_d7501.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
      alt: 'mmmm... pizza',
    },
    {
      path: '/public/val/erikskal_f0dab.gif',
      width: 600,
      height: 1100,
      mimeType: 'image/gif',
      alt: 'visuelt',
    },
    {
      path: '/public/val/polaroid_oj_b6830.webp',
      width: 1375,
      height: 2046,
      mimeType: 'image/webp',
      alt: 'alt på rødt??',
    },
    {
      path: '/public/val/jotunheimen_1_1d854.webp',
      width: 2000,
      height: 1333,
      mimeType: 'image/webp',
      alt: 'fjelltur',
    },
    {
      path: '/public/val/adam_9a1a5.webp',
      width: 800,
      height: 533,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/sticker_86882.gif',
      width: 338,
      height: 600,
      mimeType: 'image/gif',
      alt: 's',
    },
    {
      path: '/public/val/polaroid_martin_mathilde_1394a.webp',
      width: 819,
      height: 1340,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/blank_seddel_ffa83.webp',
      width: 2000,
      height: 1292,
      mimeType: 'image/webp',
      alt: 'Blank valuta',
    },
    {
      path: '/public/val/polaroid_kevin_maria_bb824.webp',
      width: 1345,
      height: 827,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/visuelt_gjeng_6bdea.jpg',
      width: 2000,
      height: 1500,
      mimeType: 'image/jpeg',
      alt: 'priiis',
    },
    {
      path: '/public/val/byob_d5953.gif',
      width: 800,
      height: 800,
      mimeType: 'image/gif',
      alt: 'b',
    },
    {
      path: '/public/val/vetle_scan_6f1bd.png',
      width: 2000,
      height: 2829,
      mimeType: 'image/png',
      alt: 'scan',
    },
    {
      path: '/public/val/skjerm_kontor_02ad0.webp',
      width: 1098,
      height: 1080,
      mimeType: 'image/webp',
      alt: 'Skjermen på kontoret',
    },
    {
      path: '/public/val/bil_a8e43.webp',
      width: 655,
      height: 786,
      mimeType: 'image/webp',
      alt: 'Blank Bedriftsidrettslag',
    },
    {
      path: '/public/val/polaroid_olaf_zaim_86088.webp',
      width: 1338,
      height: 820,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/slalom_3cdcc.webp',
      width: 1169,
      height: 2081,
      mimeType: 'image/webp',
      alt: 'Hemsedal',
    },
    {
      path: '/public/val/fredag_kontor_542ad.webp',
      width: 1920,
      height: 1080,
      mimeType: 'image/webp',
      alt: 'Fredag!',
    },
    {
      path: '/public/val/sydney_263f1.webp',
      width: 2000,
      height: 2666,
      mimeType: 'image/webp',
      alt: 'Sydney',
    },
    {
      path: '/public/val/polaroid_martin_cornelia_14646.webp',
      width: 769,
      height: 478,
      mimeType: 'image/webp',
      alt: 'Julebord',
    },
    {
      path: '/public/val/bboy_infinite_989d9.webp',
      width: 1200,
      height: 1526,
      mimeType: 'image/webp',
      alt: 'bboy infinite',
    },
    {
      path: '/public/val/dj_b9778.png',
      width: 2000,
      height: 2667,
      mimeType: 'image/png',
      alt: 'dj ',
    },
    {
      path: '/public/val/neva_bedsprett_95412.webp',
      width: 2000,
      height: 3020,
      mimeType: 'image/webp',
      alt: 'Bedriftsspretten',
    },
    {
      path: '/public/val/polaroid_veske_dfb6e.webp',
      width: 1342,
      height: 826,
      mimeType: 'image/webp',
      alt: 'mystisk',
    },
    {
      path: '/public/val/bildevegg_af579.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
      alt: 'meta',
    },
    {
      path: '/public/val/10ar_1b401.gif',
      width: 400,
      height: 400,
      mimeType: 'image/gif',
      alt: '10 år i gamet!',
    },
    {
      path: '/public/val/trykk_kristine_d0c62.webp',
      width: 1086,
      height: 610,
      mimeType: 'image/webp',
      alt: 'trykk',
    },
    {
      path: '/public/val/kontoret_01ad2.webp',
      width: 1664,
      height: 2496,
      mimeType: 'image/webp',
      alt: 'kaffepause',
    },
    {
      path: '/public/val/max_bedsprett_8321f.webp',
      width: 2000,
      height: 3019,
      mimeType: 'image/webp',
      alt: 'Bedriftsspretten',
    },
    {
      path: '/public/val/blankolympics_jon_fa04a.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
      alt: 'M',
    },
    {
      path: '/public/val/blankolympics_bendik_8c463.webp',
      width: 2000,
      height: 1500,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/blankolympics_astri_ea4fa.webp',
      width: 2000,
      height: 1500,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/blankolympics_mira_6c38c.webp',
      width: 2000,
      height: 2667,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/uranostind_vetle_fb5bd.webp',
      width: 2736,
      height: 3648,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/uranostind_astri2_95b09.webp',
      width: 2736,
      height: 3648,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/uranostind_gjeng_f21a1.webp',
      width: 2736,
      height: 3648,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/magne_silje_8a6de.webp',
      width: 2000,
      height: 1333,
      mimeType: 'image/webp',
    },
    {
      path: '/public/val/mira_jon_pizza_83b5f.jpg',
      width: 2000,
      height: 2667,
      mimeType: 'image/jpeg',
      alt: 'M',
    },
    {
      path: '/public/val/sergey_astri_mathilde_ac575.jpg',
      width: 2000,
      height: 1500,
      mimeType: 'image/jpeg',
      alt: 'Post klatring',
    },
    {
      path: '/public/val/terje_disco_2f3b6.jpg',
      width: 2000,
      height: 2667,
      mimeType: 'image/jpeg',
      alt: 'Disco',
    },
  ],
});
